// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table, Button } from 'semantic-ui-react';
import _ from 'lodash';
import DateFNS from 'date-fns';
// import DateFNSPT from 'date-fns/locale/pt';
// local
import t from 'app/lib/i18n';
import { formatNumber /*fromUTC*/ } from 'app/lib/helper';
// views
import EmptyList from 'app/ui/commons/emptyList/EmptyList';

class ReportChanges extends Component {
    renderEmpty = () => <EmptyList emptyMessage="Não foram encontradas informações para o filtro configurado." />;

    renderTable(data, auth, onClickSave) {
        const { dateFrom, dateTo, rows, client, /*timeAverage,*/ totalWasted, startAverage } = data;
        return (
            <React.Fragment>
                <div className="report">
                    <div className="date">
                        <span className="bold">Período:</span> {dateFrom} à {dateTo}
                    </div>
                    <div className="header">
                        <div className="title">SALVUS ATAS | Relatório de Momento da Troca de Cilindros</div>
                        <div className="content">
                            <div>
                                Cliente: <span className="bold wrap">{client.name}</span>
                            </div>
                            <div>
                                Perfil: <span className="bold wrap">{t(`account_profile_${auth.account.profile}`)}</span>
                            </div>
                            <div>
                                Operador: <span className="bold wrap">{auth.account.name}</span>
                            </div>
                        </div>
                    </div>
                    <div className="body">
                        <Table>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell colSpan={2} textAlign="center" />
                                    <Table.HeaderCell textAlign="center" colSpan="3" className="lastChangeReport">
                                        ÚLTIMA LEITURA
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" colSpan="3" className="newChangeReport">
                                        NOVA LEITURA
                                    </Table.HeaderCell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.HeaderCell textAlign="center">PACIENTE</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center">FORNECEDOR</Table.HeaderCell>
                                    <Table.HeaderCell className="lastDate">DATA</Table.HeaderCell>
                                    <Table.HeaderCell>HORA</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" className="lastPressure">
                                        PRESSÃO
                                    </Table.HeaderCell>
                                    <Table.HeaderCell>DATA</Table.HeaderCell>
                                    <Table.HeaderCell>HORA</Table.HeaderCell>
                                    <Table.HeaderCell textAlign="center" className="newPressure">
                                        PRESSÃO
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {_.map(rows, row => {
                                    const { begin, end, patient } = row;
                                    const key = _.uniqueId('row');
                                    return (
                                        <Table.Row key={key}>
                                            <Table.Cell>{patient.name}</Table.Cell>
                                            <Table.Cell>{patient.supplier.name}</Table.Cell>
                                            <Table.Cell style={{ borderLeft: '1px solid #747474' }}>{DateFNS.format(end.date, 'DD/MM/YYYY')}</Table.Cell>
                                            <Table.Cell>{DateFNS.format(end.date, 'HH:mm:ss')}</Table.Cell>
                                            <Table.Cell textAlign="center" style={{ borderRight: '1px solid #747474' }}>
                                                {formatNumber(end.pressure)}
                                            </Table.Cell>
                                            <Table.Cell>{DateFNS.format(begin.date, 'DD/MM/YYYY')}</Table.Cell>
                                            <Table.Cell>{DateFNS.format(begin.date, 'HH:mm:ss')}</Table.Cell>
                                            <Table.Cell textAlign="center" style={{ borderRight: '1px solid #747474' }}>
                                                {formatNumber(begin.pressure)}
                                            </Table.Cell>
                                        </Table.Row>
                                    );
                                })}
                            </Table.Body>
                            <Table.Footer>
                                <Table.Row>
                                    <Table.Cell colSpan="4" />
                                    <Table.Cell textAlign="center">Desperdício</Table.Cell>
                                    <Table.Cell textAlign="center" colSpan="2" />
                                    <Table.Cell textAlign="center">Não Entregue</Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell colSpan="4">TOTAL</Table.Cell>
                                    <Table.Cell textAlign="center">
                                        {formatNumber(totalWasted)}M<sup>3</sup>
                                    </Table.Cell>
                                    <Table.Cell textAlign="center" colSpan="2" />
                                    <Table.Cell textAlign="center">
                                        {formatNumber(startAverage)}M<sup>3</sup>
                                    </Table.Cell>
                                </Table.Row>
                            </Table.Footer>
                        </Table>
                    </div>
                </div>
                <Button className="btn-save" onClick={onClickSave}>
                    Salvar PDF
                </Button>
            </React.Fragment>
        );
    }

    render() {
        const { onClickSave, auth, data } = this.props;
        return _.isEmpty(data.rows) ? this.renderEmpty() : this.renderTable(data, auth, onClickSave);
    }
}

ReportChanges.propTypes = {
    data: PropTypes.object,
    auth: PropTypes.object,
    onClickSave: PropTypes.func,
};

export default ReportChanges;
